import { render, staticRenderFns } from "./freeElectric.vue?vue&type=template&id=1c8d56cd&"
import script from "./freeElectric.vue?vue&type=script&lang=js&"
export * from "./freeElectric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports